import { compact, get, uniq } from "lodash";
import { BOMFormat } from "./base";
/**
 * Default app name used when no custom name is provided.
 * This can be overridden by passing a custom manufacturer name to the constructor.
 */
const DEFAULT_APP_NAME = "Flux";
export class FluxFormat extends BOMFormat {
    static manufacturer = DEFAULT_APP_NAME;
    static columns = {
        Designator: (item) => item.designators.join(","),
        Quantity: "quantity",
        "Element UIDs": (item) => item.elementUids.join(","),
        "Part UID": "partUid",
        Specification: (item) => item.specification.join(", "),
    };
    _manufacturerName;
    constructor(lineItems, manufacturerName) {
        super(lineItems);
        this._manufacturerName = manufacturerName ?? DEFAULT_APP_NAME;
    }
    get name() {
        return this._manufacturerName;
    }
    get columns() {
        const baseColumns = FluxFormat.columns;
        const lineItemColumns = this.lineItems.reduce((cols, lineItem) => {
            // eslint-disable-next-line @buildwithflux/no-array-foreach
            Object.values(lineItem.elementProperties).forEach((propertySet) => {
                // eslint-disable-next-line @buildwithflux/no-array-foreach
                Object.keys(propertySet).forEach((property) => {
                    cols[property] = (item) => {
                        return uniq(compact(item.elementUids.map((uid) => get(item.elementProperties, [uid, property])))).join(",");
                    };
                });
            });
            return cols;
        }, {});
        return { ...baseColumns, ...lineItemColumns };
    }
}
//# sourceMappingURL=Flux.js.map